/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DashboardPageBlockCartesianSerieMilestone'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/DashboardPageBlockCartesianSerieMilestone'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DashboardPageBlockCartesianSerieMilestoneApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.DashboardPageBlockCartesianSerieMilestone);
  }
}(this, function(ApiClient, DashboardPageBlockCartesianSerieMilestone) {
  'use strict';

  /**
   * DashboardPageBlockCartesianSerieMilestone service.
   * @module api/DashboardPageBlockCartesianSerieMilestoneApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new DashboardPageBlockCartesianSerieMilestoneApi. 
   * @alias module:api/DashboardPageBlockCartesianSerieMilestoneApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the dashboardPageBlockCartesianSerieMilestoneAddPut operation.
     * @callback module:api/DashboardPageBlockCartesianSerieMilestoneApi~dashboardPageBlockCartesianSerieMilestoneAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/DashboardPageBlockCartesianSerieMilestone} body 
     * @param {module:api/DashboardPageBlockCartesianSerieMilestoneApi~dashboardPageBlockCartesianSerieMilestoneAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.dashboardPageBlockCartesianSerieMilestoneAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockCartesianSerieMilestoneAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageBlockCartesianSerieMilestoneAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/DashboardPageBlockCartesianSerieMilestone/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageBlockCartesianSerieMilestoneDeleteGet operation.
     * @callback module:api/DashboardPageBlockCartesianSerieMilestoneApi~dashboardPageBlockCartesianSerieMilestoneDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/DashboardPageBlockCartesianSerieMilestoneApi~dashboardPageBlockCartesianSerieMilestoneDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dashboardPageBlockCartesianSerieMilestoneDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockCartesianSerieMilestoneDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling dashboardPageBlockCartesianSerieMilestoneDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DashboardPageBlockCartesianSerieMilestone/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageBlockCartesianSerieMilestoneEditPut operation.
     * @callback module:api/DashboardPageBlockCartesianSerieMilestoneApi~dashboardPageBlockCartesianSerieMilestoneEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/DashboardPageBlockCartesianSerieMilestone} body 
     * @param {module:api/DashboardPageBlockCartesianSerieMilestoneApi~dashboardPageBlockCartesianSerieMilestoneEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dashboardPageBlockCartesianSerieMilestoneEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockCartesianSerieMilestoneEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageBlockCartesianSerieMilestoneEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DashboardPageBlockCartesianSerieMilestone/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageBlockCartesianSerieMilestoneLoadAllGet operation.
     * @callback module:api/DashboardPageBlockCartesianSerieMilestoneApi~dashboardPageBlockCartesianSerieMilestoneLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/DashboardPageBlockCartesianSerieMilestone>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/DashboardPageBlockCartesianSerieMilestoneApi~dashboardPageBlockCartesianSerieMilestoneLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/DashboardPageBlockCartesianSerieMilestone>}
     */
    this.dashboardPageBlockCartesianSerieMilestoneLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockCartesianSerieMilestoneLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [DashboardPageBlockCartesianSerieMilestone];

      return this.apiClient.callApi(
        '/DashboardPageBlockCartesianSerieMilestone/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
